import { JSONRPCClient } from 'json-rpc-2.0';
import type { JSONRPCResponse } from 'json-rpc-2.0';

export default class JSONRPC {
  private client: JSONRPCClient;
  private nextID = 0;

  constructor(send: (message: unknown) => void) {
    this.client = new JSONRPCClient(send);
  }

  async request<T = unknown>(method: string, params: unknown[] = []): Promise<T> {
    // The advanced API preserves the plain error objects expected by Qt callers.
    const response = await this.client.requestAdvanced(
      { jsonrpc: '2.0', id: ++this.nextID, method, params },
      undefined
    );
    if (response.error) throw response.error;
    return response.result as T;
  }

  handleResponse(response: unknown): void {
    // Legacy Qt responses omit jsonrpc, and errors may omit code. receive()
    // correlates by id without validating those fields; preserve the payload.
    this.client.receive(response as JSONRPCResponse);
  }
}
